module.exports = __webpack_public_path__ + "img/gambero-rosso.324b247b.png";